import { memo, useMemo } from 'react';
import type { AnchorHTMLAttributes } from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { isInternalURL } from '@plone/volto/helpers';

import ImageBanner from './ImageBanner';

const SlideItem = ({ item, href }) => {
  const isExternal = useMemo(() => {
    if (!href) return false;
    try {
      return !isInternalURL(href);
    } catch {
      return false;
    }
  }, [href]);

  const target = item?.openLinkInNewTab || isExternal ? '_blank' : undefined;

  const rel = target === '_blank' ? 'noreferrer noopener' : undefined;

  const content = <ImageBanner image={item?.image} alt={item?.alt || ''} />;

  const linkProps = {
    target,
    rel,
    'aria-label': 'Acessar banner institucional',
  } as AnchorHTMLAttributes<HTMLAnchorElement>;

  return (
    <li className="glide__slide">
      {href ? (
        <UniversalLink
          className="mpf-banner-topo__link"
          href={href}
          {...linkProps}
        >
          {content}
        </UniversalLink>
      ) : (
        content
      )}
    </li>
  );
};

SlideItem.propTypes = {
  item: PropTypes.shape({
    image: PropTypes.any,
    alt: PropTypes.string,
    openLinkInNewTab: PropTypes.bool,
  }).isRequired,
  href: PropTypes.string,
};

export default memo(SlideItem);
